import React from 'react';
import './ui.css';

export default function EmptyState({ icon = 'fas fa-inbox', title, description, action }) {
  return (
    <div className="ax-empty">
      <span className="ax-empty__icon"><i className={icon} aria-hidden="true" /></span>
      {title ? <div className="ax-empty__title">{title}</div> : null}
      {description ? <div className="ax-empty__desc">{description}</div> : null}
      {action ? <div className="ax-empty__actions">{action}</div> : null}
    </div>
  );
}
